import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'subscriptions',
    loadChildren: () => import('./subscription-page/subscription-page.module').then(m => m.SubscriptionsPageModule),
  },
  {
    path: 'subscription/receipt',
    loadChildren: () =>
      import('./subscription-confirmation-page/subscription-confirmation-page.module').then(
        m => m.SubscriptionConfirmationPageModule
      ),
    data: {
      feature: 'subscription',
      headerType: 'checkout',
      checkoutStep: 5,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SubscriptionRoutingModule {}
